import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { DecisionGuideSection } from '../components/DecisionGuideSection';
import { DeliverySection } from '../components/DeliverySection';
import { ForWhoSection } from '../components/ForWhoSection';
import { FaqSection } from '../components/FaqSection';
import { PricingSection } from '../components/PricingSection';
import { FooterDisclaimer } from '../components/FooterDisclaimer';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden" data-id="element-147">
      <HeroSection data-id="element-148" />
      <ProblemSection data-id="element-149" />
      <SolutionSection data-id="element-150" />
      <MechanismSection data-id="element-151" />
      <WhatYouGetSection data-id="element-152" />
      <DecisionGuideSection data-id="element-153" />
      <DeliverySection data-id="element-154" />
      <ForWhoSection data-id="element-155" />
      <FaqSection data-id="element-156" />
      <PricingSection data-id="element-157" />
      <FooterDisclaimer data-id="element-158" />
    </div>;
}